import { useTranslation } from 'react-i18next';
import {
    ApplicationCreate,
    ApplicationEdit,
    ApplicationList,
} from '../pages/applications';
import {
    PreliminaryApplicationCreate,
    PreliminaryApplicationEdit,
    PreliminaryApplicationList,
} from '../pages/preliminary-application';
import {
    PreliminaryApplicationOPCCreate,
    PreliminaryApplicationOPCEdit,
    PreliminaryApplicationOPCList,
} from '../pages/preliminary-application-wp';
import { PreliminaryApplicationWpNew } from '../pages/preliminary-application-wp-new';
import { PreliminaryApplicationEVNew } from '../pages/preliminary-application-ev-new';
import { PreliminaryApplicationCTANew } from '../pages/preliminary-application-cta-new';
import { ActivityList } from '../pages/activity';
import { PharmasolList, PharmasolShow } from '../pages/pharmasol';
import SpecList from '../pages/specs/list/list';
import SpecShow from '../pages/specs/show/show';
import {
    ExperimentOutlined,
    FormOutlined,
    FundProjectionScreenOutlined,
} from '@ant-design/icons';

export const useLocalizedResources = () => {
    const { t } = useTranslation();

    const rawResources = [
        {
            name: 'applications',
            list: ApplicationList,
            create: ApplicationCreate,
            edit: ApplicationEdit,
            icon: <FormOutlined />,
            options: {
                label: t('applications.applications'),
            },
            meta: {
                layout: 'dashboard',
                internalLayoutActions: ['add', 'create', 'edit'],
            },
        },
        {
            name: 'preliminary-applications',
            list: PreliminaryApplicationList,
            create: PreliminaryApplicationCreate,
            edit: PreliminaryApplicationEdit,
            icon: <FormOutlined />,
            options: {
                label: t('preliminary-applications.preliminary-applications'),
            },
            meta: {
                layout: 'dashboard',
                internalLayoutActions: ['create', 'edit'],
            },
        },
        {
            name: 'preliminary-applications-ev-new',
            list: PreliminaryApplicationEVNew,
            icon: <FormOutlined />,
            options: {
                label: t(
                    'preliminary-applications-ev-new.preliminary-applications'
                ),
            },
        },
        {
            name: 'preliminary-applications-cta-new',
            list: PreliminaryApplicationCTANew,
            icon: <FormOutlined />,
            options: {
                label: t(
                    'preliminary-applications-cta-new.preliminary-applications'
                ),
            },
        },
        {
            name: 'preliminary-applications-wp',
            list: PreliminaryApplicationOPCList,
            create: PreliminaryApplicationOPCCreate,
            edit: PreliminaryApplicationOPCEdit,
            icon: <FormOutlined />,
            options: {
                label: t(
                    'preliminary-applications-wp.preliminary-applications'
                ),
            },
            meta: {
                layout: 'dashboard',
                internalLayoutActions: ['create', 'edit'],
            },
        },
        {
            name: 'preliminary-applications-wp-new',
            list: PreliminaryApplicationWpNew,
            icon: <FormOutlined />,
            options: {
                label: t(
                    'preliminary-applications-wp-new.preliminary-applications'
                ),
            },
        },
        {
            name: 'applications-external',
            list: () => null,
            options: {
                label: t(
                    'applications_external_page.applications_external_page'
                ),
            },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'form',
            list: () => null,
            options: { label: t('form') },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'history',
            list: () => null,
            options: { label: t('history') },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'clinical-trial',
            list: () => null,
            options: { label: t('clinicaltrial_items') },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'menu-forms',
            list: () => null,
            options: { label: t('menuforms') },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'activity',
            list: ActivityList,
            icon: <FundProjectionScreenOutlined />,
            options: { label: t('activity.activity') },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'dictionaries',
            list: PharmasolList,
            show: PharmasolShow,
            icon: <ExperimentOutlined />,
            options: { label: t('pharmasol.dictionaries') },
            meta: {
                layout: 'dashboard',
            },
        },
        {
            name: 'specs',
            list: SpecList,
            show: SpecShow,
            meta: {
                layout: 'dashboard',
            },
        },
    ];

    const resourcesWithLayout = rawResources.map(resource => ({
        ...resource,
        meta: {
            ...resource.meta,
            layout: resource?.meta?.layout ?? 'dashboard',
        },
    }));

    return resourcesWithLayout;
};
